// extracted by mini-css-extract-plugin
module.exports = {"page":"page--page--30zjZ","header":"page--header--ziQ_p"};